let users = localStorage.getItem('users');

export const permissionView = (name, actions) => {
    ///check role users
    let checkUser = JSON.parse(users);
;

    if (checkUser.roles[0].permission === "admin") return true;

    console.log("Aa" , name)
    const result = JSON.parse(localStorage.getItem('permissions')).find(item => item.page.title === name);
    if (!result) return false;

    return (actions === 'view') ? views(result) : (actions === 'edit') ? edits(result) : deletes(result)

}
let views = (result) => {
    console.log(result.view);
    return (result.view === 'allow') ? true : false
}

let edits = (result) => {

    return (result.view === 'allow') ? true : false
}

let deletes = (result) => {
    return (result.view === 'allow') ? true : false
}